/**
 * A press that is with the scheduler (1.5.15): Finish, Arrived, Confirm by phone, Move and Cancel put a request in
 * a queue and the scheduler answers on its next run — a few minutes. Until then this one line stands where the
 * button was: a clock and words (never colour alone), the time it was pressed, as a status. Nothing to press.
 */
import { useTranslation } from 'react-i18next';
import { formatClockOf } from '@/lib/dates';
import { Icon } from './Icons';

export function WithScheduler({ at, closeout = false, testid = 'with-scheduler' }: { at?: string | null; /** Finish: "Closing out…" */ closeout?: boolean; testid?: string }) {
  const { t, i18n } = useTranslation();
  const pressed = at && !Number.isNaN(Date.parse(at)) ? formatClockOf(at, i18n.language) : null;
  return (
    <span className="with-scheduler" role="status" data-testid={testid}>
      <Icon name="clock" />
      <span>
        {t(closeout ? 'tx.closingOut' : 'tx.withScheduler')}
        {pressed ? <span className="tnum"> · {t('tx.pressedAt', { time: pressed })}</span> : null}
      </span>
    </span>
  );
}
